import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { MarkerComponent } from './marker.component';
import { TwoLettersPipeModule } from '@go-modules/pipes/two-letters/two-letters.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		TwoLettersPipeModule,
		MatTooltipModule
	],
	exports: [
		MarkerComponent
	],
	declarations: [
		MarkerComponent
	]
})
export class MarkerModule {}
